module.exports = __webpack_public_path__ + "media/images/hitfun/icon.trend.up-b86488164d8cc57b4e04a476d6669001.svg";